<!---App-context -->
<div class="wrapper no-footer" [class.embed-mode]="embedMode.isEmbedded"
    [class.sample-poll-overlay-banner]="appShellService.isSamplePollRoute">
    <div class="app-container">
        <!--Embed-Mode hat keine sticky-bar: kompakter Slot nur fuer den Verbindungs-Hinweis-->
        <ess-banner *ngIf="embedMode.isEmbedded && connectionStalledBanner?.getShowBanner()" class="compact"></ess-banner>
        <div *ngIf="!appShellService.getShowContextBar()  && ! appShellService.isStepper" class="marging-top">
        </div>
        <!--Bars: im Embed-Mode komplett unterdrueckt (siehe EmbedModeService) -->
        <sticky-bar *ngIf="!embedMode.isEmbedded">
            <nav-bar *ngIf="appShellService.showNavBarInWhooApp">
            </nav-bar>
            <vote-bar *ngIf="appShellService.showVoteBarInWhooApp">
            </vote-bar>
            <vote-bar-invite *ngIf="appShellService.showVoteBarInWhooAppInvite">
            </vote-bar-invite>
            <div *ngIf="appShellService.getShowContextBar()" class="context-bar-container">
                <div class="context-bar ">
                    <context-action-bar> </context-action-bar>
                </div>
            </div>
            <!--der Banner-Slot fehlt auf den Vote-/Create-Routen; der Verbindungs-Hinweis braucht ihn gerade dort-->
            <ess-banner *ngIf="appShellService.getShowBanner() || connectionStalledBanner?.getShowBanner()"> </ess-banner>
        </sticky-bar>
        <!--Content-->
        <div class="page-container">
            <div class="offline-message-container  whoo-centered-container-fit-content" *ngIf="!online">
                <span class="offline-message">{{ 'you-are-offline' | transMigrated | async}}</span>
            </div>
            <!-- router outlet-->
            <router-outlet></router-outlet>
            <!--reCAPTCHA-Hinweis (App Check): auf jeder Route, auch im Embed-Mode - ersetzt das per CSS ausgeblendete Badge-->
            <recaptcha-notice *ngIf="translationLoaded"></recaptcha-notice>
        </div>

    </div>
    <!--Feedback / Cookie-Consent: im Embed-Mode unterdrueckt -->
    <feedback-button *ngIf="!embedMode.isEmbedded"></feedback-button>
    <cookie-consent *ngIf="!embedMode.isEmbedded"></cookie-consent>

    <!--Progress Bar-->
    <app-progress-bar *ngIf="authService.isLoading || !translationLoaded">
    </app-progress-bar>

    <!--Sample-Poll Kopier-Overlay: blockt UI waehrend copyPoll + clearSampleFlags
        + Anonymous-Signup laufen, damit der User Feedback hat dass etwas passiert. -->
    <div *ngIf="samplePollCopyService.isLoading" class="sample-poll-copy-overlay">
        <ess-spinner></ess-spinner>
    </div>
</div>
